import { useContext } from "react";
import { NavigationGuardContext } from "./navigation-guard-context";

export function useNavigationGuard() {
  const ctx = useContext(NavigationGuardContext);
  if (!ctx) {
    throw new Error(
      "useNavigationGuard must be used within a NavigationGuardProvider"
    );
  }
  return ctx;
}
